/**
 * Session-storage-based token handoff for poll import prefill.
 *
 * Saves a normalized poll payload under a unique key, returns a token.
 * The consumer reads + removes the entry in one shot.
 */

const PREFIX = "pollImport:";

/**
 * Persist a normalized poll payload and return a one-time-use token.
 * @param {object} normalizedPayload - Output from validatePollJson().normalized
 * @returns {string} token
 */
export function savePollImportToken(normalizedPayload) {
  const token = crypto.randomUUID();
  sessionStorage.setItem(`${PREFIX}${token}`, JSON.stringify(normalizedPayload));
  return token;
}

/**
 * Consume a previously saved import token. Returns the payload once, then deletes it.
 * @param {string} token
 * @returns {object|null} Parsed payload or null if missing/invalid.
 */
export function consumePollImportToken(token) {
  if (!token) return null;
  const key = `${PREFIX}${token}`;
  const raw = sessionStorage.getItem(key);
  if (raw == null) return null;
  sessionStorage.removeItem(key);
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}
